<template>
  <div
    class="option-object px-4 my-2"
    :style="{ width: componentWidth + 'px' }"
  >
    <!-- Start Modal -->

    <!-- START OPTION PANEL-->
    <div
      class="break-words bg-white rounded-lg mb-6 xl:mb-0 shadow h-full border border-solid px-4 pb-4"
      :class="step.panelWidthClass"
      :style="{ 'background-color': panelColor, 'border-color': borderColor }"
    >
      <!-- START SETTINGS VIEW -->

      <div v-if="showSettings == true" class="">
        <div class="flex flex-row-reverse">
          <div @click="showSettings = false">
            <svg-icon
              icon="heroicons/solid/x"
              class="w-6 h-6 opacity-50 hover:opacity-100 cursor-pointer mt-2"
            />
          </div>
        </div>

        <div class="col-span-6 sm:col-span-3">
          <label for="goto" class="block text-sm font-medium text-gray-700"
            >On selection go to:
          </label>
          <select
            v-model="goto"
            id="goto"
            name="goto"
            autocomplete="goto"
            class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
          >
            <option value="next" class="italic font-bold">The next step in sequence</option>
            <option value="link" class="italic font-bold">An External link </option>
            <option
              :key="index"
              v-for="(step, index) in survey.steps"
              :value="step.auto_id"
            >
              <span class="font-bold" v-text="step.title || 'Step ' + (index+1)"> </span
              >
            </option>
            
          </select>
        </div>

        <div v-show="option.goto == 'link'" class="col-span-3 sm:col-span-2">
          <label class="block text-sm font-medium text-gray-700 mt-3">
            Link:
          </label>
          <div class="mt-1 flex rounded-md shadow-sm">
            <input
              type="text"
              class="py-2 px-3 focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full rounded-none rounded-md sm:text-sm border border-solid border-gray-300"
              placeholder="http://www.example.com"
              v-model="gotoLink"
            />
          </div>
        </div>

        <hr />
        <div class="col-span-6 sm:col-span-3 mt-5">
          <label class="block text-sm font-medium text-gray-700"
            >Set a custom value:
            <svg-icon
              icon="heroicons/solid/question-mark-circle"
              class="h-4 w-4 inline-block"
              svgClass="inline"
              v-tooltip="'Customize the value shown in your reports'"
            ></svg-icon>
          </label>

          <input
            v-model="value"
            type="text"
            class="py-2 px-3 focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full rounded-none rounded-md sm:text-sm border border-solid border-gray-300"
            :placeholder="option.title"
          />
        </div>

        <!-- Hide this for now, until integrations are added 
        <div class="col-span-6 sm:col-span-3 mt-5">
          <label for="mapField" class="block text-sm font-medium text-gray-700"
            >Map choice to custom field:
          </label>
          <select
            v-model="option.mapField"
            id="mapField"
            name="mapField"
            autocomplete="mapField"
            class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
          >
            <option default>No integration set.</option>
          </select>
        </div>
        -->
      </div>

      <!--START MAIN VIEW -->

      <div v-else>
        <div class="flex flex-row-reverse justify-between my-handle pt-4">
          <BaseDropDown
            v-tooltip="'Option menu'"
            class="flex-none"
            v-on:show-settings="showSettings = true"
            v-on:remove-option="$emit('remove-option', option)"
            v-on:clone-option="$emit('clone-option', option)"
            v-bind:items="[
              {
                event: 'show-settings',
                label: 'Option settings',
                icon: 'heroicons/outline/cog',
              },
              {
                event: 'clone-option',
                args: option,
                label: 'Clone option',
                icon: 'heroicons/outline/duplicate',
              },
              {
                event: 'remove-option',
                args: option.id,
                label: 'Delete option',
                icon: 'heroicons/outline/x-circle',
              },
            ]"
          >
          </BaseDropDown>

          <div
            class="flex-auto text-white hover:text-gray-400 flex justify-center"
          >
            <div class="ml-10 -mt-2" v-tooltip="{ content: 'Drag to reorder' }">
              <span
                style="transform: rotate(90deg);font-size:28px"
                class="material-icons"
                >drag_indicator</span
              >
            </div>
          </div>
        </div>

        <div
          v-on:click="openModal(option)"
          :class="imageHeightClass"
          class="flex flex-col justify-center display-block mx-auto border border-solid border-transparent hover:border-blue-200 cursor-pointer rounded"
          :style="{ color: accentColor }"
        >
          <img
            v-if="option.image == 'link'"
            :src="option.image_link"
            class="display-block mx-auto max-w-full max-h-full"
          />
          <svg-inline
            v-else
            class="display-block mx-auto h-full"
            :copyAttrs="true"
            :image="image"
          />
        </div>

        <div class="p-4">
          

          <option-text
            v-for="content in contents"
            :key="content.id"
            @close-menu="$emit('close-menu')"
            :content_id="content.id"
            :survey="survey"
            :dragging="$store.state.dragging"
            :step="step"
            :style="{
              'margin-top': content.marginTop + 'px',
              'margin-bottom': content.marginBottom + 'px',
            }"
            class="text-center"
          >
          </option-text>

          <div
            v-if="contents.length < 2"
            @click="addText"
            class=" rounded-full"
          >
            <svg-icon
              icon="heroicons/outline/plus"
              class="plus-icon bottom cursor-pointer text-purple-600 bg-white rounded-full"
              v-tooltip="'Add text'"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import OptionText from "@/components/Builder/OptionText.vue";
import Content from "@/models/content/Content";
import Option from "@/models/Option";
import Text from "@/models/content/Text";
//import Survey from "@/models/Survey";
import EventBus from "@/event-bus.js";

export default {

  components: {
    OptionText,
  },
  data() {
    return {
      showModal: false,
      showSettings: false,
    };
  },
  props: ["survey", "step", "option"],
  computed: {
    contents: {
      get() {
        //return this.option.contents;
        return Content.query()
          .where("parent_id", this.option.id)
          .orderBy("order", "asc")
          .get();
      },
      set(list) {
        var reorderedList = Content.reIndexList(list);
        Content.update({
          data: reorderedList,
        });
      },
    },
    componentWidth() {
      return this.step.maxPanelWidth() + 32;
    },
    imageHeightClass() {
      return this.step.imageHeightClass;
    },
    panelColor() {
      return this.survey.panelColor;
    },
    accentColor() {
      return this.survey.accentColor;
    },
    /*
    fontColor() {
      return this.survey.fontColor;
    },
    fontColor2() {
      return this.survey.fontColor2;
    },
    font() {
      return this.survey.font;
    },
    */
    borderColor() {
      return this.survey.borderColor;
    },
    size() {
      return this.step.size;
    },
    goto: {
      get() {
        return this.option.goto;
      },
      set(value) {
        if (value !== this.option.goto) {
          Option.update({ where: this.option.id, data: { goto: value } });
        }
      },
    },
    value: {
      get() {
        return this.option.value;
      },
      set(value) {
        if (value !== this.option.value) {
          Option.update({ where: this.option.id, data: { value: value } });
        }
      },
    },
    gotoLink: {
      get() {
        return this.option.goto_link;
      },
      set(value) {
        if (value !== this.option.goto_link) {
          Option.update({ where: this.option.id, data: { goto_link: value } });
        }
      },
    },
    image: {
      get() {
        return this.option.image;
      },
      set(value) {
        if (value !== this.option.image) {
          Option.update({ where: this.option.id, data: { image: value } });
        }
      },
    },
    imageLink: {
      get() {
        return this.option.image_link;
      },
      set(value) {
        Option.update({
          where: this.option.id,
          data: { image_link: value, image: "link" },
        });
      },
    },

    title: {
      get() {
        return this.option.title;
      },
      set(value) {
        if (value !== this.option.title) {
          Option.update({ where: this.option.id, data: { title: value } });
        }
      },
    },
    description: {
      get() {
        return this.option.description;
      },
      set(value) {
        if (value !== this.option.description) {
          Option.update({
            where: this.option.id,
            data: { description: value },
          });
        }
      },
    },
  },

  methods: {
    addText() {
      let text = {
        parent_id: this.option.id,
        parent_type: "option",
        type: "TEXT",
        text: "Some text here",
        fontSize: 18,
      };

      Text.insert({ data: text });
    },
    openModal: function() {
      EventBus.$emit('open-modal', this.option);
      //this.showModal = true;
      //window.addEventListener("keydown", this.onEscape);
    },
    /*
    closeModal: function() {
      this.showModal = false;
      window.removeEventListener("keydown", this.onEscape);
    },
    onEscape: function(e) {
      if (this.showModal && e.keyCode === 27) {
        this.closeModal();
      }
    },
    */
  },
  destroyed() {
    //window.removeEventListener("keydown", this.onEscape);
  },
};
</script>

<style>
.my-handle {
  cursor: move;
}
</style>
